import { render, staticRenderFns } from "./AreaUnidadesTable.vue?vue&type=template&id=1ee94a1d&scoped=true&"
import script from "./AreaUnidadesTable.vue?vue&type=script&lang=js&"
export * from "./AreaUnidadesTable.vue?vue&type=script&lang=js&"
import style0 from "./AreaUnidadesTable.vue?vue&type=style&index=0&id=1ee94a1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee94a1d",
  null
  
)

export default component.exports